import { styled } from '@mui/material';
import { useViewport } from 'contexts/viewport';
import { Box, Logo } from 'shell/components';

const LogoOnlyHeader = () => {
    const { device } = useViewport();

    return (
        <Root device={device}>
            <Logo device={device} />
        </Root>
    );
};

const Root = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'device',
})(({ device, theme }) => ({
    height: device === 'mobile' ? '64px' : '60px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: device === 'mobile' ? theme.spacing(0, 5) : theme.spacing(2.5, 5),
}));

export default LogoOnlyHeader;
